import municipioList from "./municipioList/municipioList.vue";
import i18n from "../../i18n/index";
import locationService from '../../services/location/LocationService.js';
import cityService from '../../services/location/CityService';

export default {
    components: {
        municipioList
    },
    data: () => ({
        hideList: false,
        editProccess: false,
        mun: {
            name: '',
            idState: '',
            code: ''
        },
        update: 0,
        rules: [value => !!value || i18n.t('field-required')],
        validForm: true,
        loadingSaveButton: false,
        states: [],
        cities: [],
        loadingDelete: false,
        showDelete: false
    }),
    created() {
        this.getStates();
    },
    methods: {
        handleMunicipio(item) {
            this.hideList = true;
            this.showIcon = false;
            this.mun.id = item.id;
            this.mun.idState = item.idState.id;
            this.mun.name = item.name;
            this.mun.code = item.code;
            this.editProccess = true;
            this.update = 1;
            this.loadingDelete = false;
            this.showDelete = true;
        },
        closeUser() {
            this.hideList = false;
            this.dialog = false;
            this.mun = {
                idState: '',
                name: '',
                code: ''
            }
            this.showIcon = false;
            this.$refs.municipioform.reset();
            this.editProccess = false
            this.update = 0;
            this.showDelete = false;
        },
        async getStates() {
            await locationService.getStatesByCountry().then(response => {
                this.states = response.data;
            });
        },
        save() {
            if (!this.$refs.municipioform.validate()) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.error-required-fields")
                });
                return;
            }
            // this.mun.id = this.mun.id == '' ? this.$refs.munipicioList.getLenght() + 1 : this.mun.id;
            this.editProccess = false
            cityService.createProvider(this.mun)
                .then(result => {
                    if (result.status == 200 || result.status == 201) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: i18n.t("record-successfully-created")
                        });

                    }
                    this.$refs.municipioList.searchCity();
                    this.closeUser();
                })
                .catch(err => {
                    throw err;
                });
        },
        updateMunicipio() {
            let municipioId = this.mun.id;
            let data = {
                name: this.mun.name,
                idState: this.mun.idState,
                code: this.mun.code
            };
            cityService.updateCities(municipioId, data)
                .then(result => {
                    if (result.status == 200) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: i18n.t("record-update")
                        });
                        this.$refs.municipioList.searchCity();
                        this.closeUser();
                    }

                })
                .catch(err => {
                    throw err;
                });
        },
        deleteMunicipio() {
            let data = { id: this.mun.id };
            this.loadingDelete = true;
            cityService.deleteCities(data).then(result => {
                if (result.status == 200) {
                    this.loadingDelete = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: 'Municipio Eliminado'
                    });
                    this.$refs.municipioList.searchCity();
                    this.closeUser();
                }
            }).catch(error => {
                this.loadingDelete = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error.code == 'The city has associated transactions') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "El municipio tiene transacciones no se puede eliminar"
                        })
                    }
                }
                // this.$refs.municipioList.searchCity();
                // this.closeUser();
            });
        }
    }
}